export const showLanguageSwitchButton =
  process.env.REACT_APP_ENV === 'development';
